import React from 'react';
import { ShieldCheckIcon, TruckIcon, BanIcon } from 'lucide-react';
const items = [{
  icon: ShieldCheckIcon,
  title: '60-Day Money-Back Guarantee',
  detail: 'Full refund, opened box included'
}, {
  icon: TruckIcon,
  title: 'Tracked Shipping',
  detail: 'Ships to US, UK, CA, AU & NZ'
}, {
  icon: BanIcon,
  title: 'No Monthly Fees — Ever',
  detail: 'The app is free and stays free'
}];
export function TrustStrip() {
  return <ul className="grid grid-cols-1 gap-px overflow-hidden rounded-md border border-forest-line bg-forest-line sm:grid-cols-3" data-id="element-51" data-mp="25db6hacroadl">
      {items.map(({
      icon: Icon,
      title,
      detail
    }) => <li key={title} className="flex flex-col bg-forest-soft px-4 py-4" data-id="element-52" data-mp="20gb1l2rnldo2">
          <Icon className="h-5 w-5 text-forest-mid" aria-hidden="true" data-id="element-53" data-mp="1we7o68lfbz05" />
          <p className="mt-2 font-sans text-sm font-semibold leading-snug text-forest" data-id="element-54" data-mp="3usiyglnjc4mh">
            {title}
          </p>
          <p className="mt-auto pt-1 font-sans text-xs leading-snug text-ink-soft" data-id="element-55" data-mp="3qr5uyi7x0diq">
            {detail}
          </p>
        </li>)}
    </ul>;
}